import {
  EGENDERS,
  GetSuggestedPeople,
  GetSuggestedPeopleType,
} from "@letshang/constants"
import { filter, includes } from "lodash-es"
import { atom, selector } from "recoil"
import { getRecoil, setRecoil } from "recoil-nexus"
import { recoilPersist } from "recoil-persist"

import { fetchSuggestedBuddies } from "@api/firebaseWrappedApis"

import { reviewedBuddyStatuses } from "@fuse/utils/common"
import { parseDateWithFallback } from "@fuse/utils/dates"

const { persistAtom } = recoilPersist()

export const defaultUserInfoWithBuddies = {
  loading: true,
  homeCoordinates: {
    latitude: 0,
    longitude: 0,
    radius: 0,
    locality: "",
  },
  friends: [],
  userInfo: {
    avatarUrl: "",
    dateOfBirth: "",
    gender: EGENDERS.MALE,
    displayName: "",
    myFbId: "",
    lastUpdatedFbFriends: undefined,
    facebookTokenCredential: "",
    email: "",
    expoPushToken: "",
    country: "",
    interests: [],
  },
}

export const suggestedBuddiesAtom = atom<GetSuggestedPeople>({
  key: "suggestedBuddies",
  default: {
    loading: true,
    data: [],
    lastFetchTime: null,
  },
})

export const userInfoWithBuddiesState = atom({
  key: "defaultUserInfoWithBuddies",
  default: defaultUserInfoWithBuddies,
  effects_UNSTABLE: [persistAtom],
})

export const getSuggestedBuddiesSelector = selector({
  key: "getSuggestedBuddiesSelector",
  get: ({ get }) => {
    const getSuggestedBuddies = get(suggestedBuddiesAtom)
    return getSuggestedBuddies.data
  },
})

export const getSuggestedBuddiesLastFetch = selector({
  key: "getSuggestedBuddiesLastFetch",
  get: ({ get }) => {
    const getSuggestedBuddies = get(suggestedBuddiesAtom)
    return getSuggestedBuddies?.lastFetchTime
  },
})

const myBuddiesInfoDocsSelector = selector({
  key: "myBuddiesInfoDocsSelector",
  get: ({ get }) => {
    const friendsAndBuddyInfoReturn = get(userInfoWithBuddiesState)

    return friendsAndBuddyInfoReturn
  },
})

export const pendingBuddiesSelector = selector({
  key: "pendingBuddiesSelector",
  get: ({ get }) => {
    const { friends } = get(myBuddiesInfoDocsSelector)
    const unReviewedFriendsOnly = friends?.filter(
      (friend: any) => !reviewedBuddyStatuses.includes(friend.status),
      // !reviewedBuddyStatuses.includes(friend.fofStatus),
    )
    return unReviewedFriendsOnly
  },
})

export const reviewedBuddiesSelector = selector({
  key: "reviewedBuddiesSelector",
  get: ({ get }) => {
    const { friends } = get(myBuddiesInfoDocsSelector)
    const reviewedFriendsOnly = friends?.filter(
      (friend: any) => reviewedBuddyStatuses.includes(friend.status),
      // reviewedBuddyStatuses.includes(friend.fofStatus),
    )
    return reviewedFriendsOnly
  },
})

export const requestedSuggestedBuddiesAtom = atom<string[]>({
  key: "requestedSuggestedBuddiesAtom",
  default: [],
})

export const updateSuggestedBuddies = async (uid: string) => {
  const getRequestedSuggestedBuddies = getRecoil(requestedSuggestedBuddiesAtom)
  const updatedRequestedSuggestedBuddies = [
    ...getRequestedSuggestedBuddies,
    uid,
  ]

  fetchSuggestedBuddies({}).then((data) => {
    // Assert that data is an array of GetSuggestedPeopleType
    const typedData = data as GetSuggestedPeopleType[]

    const updatedSuggestedBuddies = typedData.filter(
      (item) => !updatedRequestedSuggestedBuddies.includes(item?.uid),
    )

    setRecoil(suggestedBuddiesAtom, {
      loading: false,
      data: updatedSuggestedBuddies,
      lastFetchTime: parseDateWithFallback(new Date()),
    })

    setRecoil(requestedSuggestedBuddiesAtom, updatedRequestedSuggestedBuddies)
  })
}
